// extracted by mini-css-extract-plugin
export default {"pagination":"pagination--JanUp","showing":"showing--JanUp","buttons":"buttons--JanUp","spacer":"spacer--JanUp","xlargeSpacer":"xlargeSpacer--JanUp"};